import Api from "../axios";

export const getViewPolicy = async (id) => {
  return await Api.get(`/view_policy?policy_id=${id}`);
};